// components/DrawnChallengeModal.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function DrawnChallengeModal({ challenge, onClose }) {
  if (!challenge) return null;

  const { text, type, category } = challenge;
  const isPositive = type === 'positive';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className={`relative bg-surface rounded-xl shadow-2xl p-8 w-full max-w-lg text-center transform transition-all duration-300 scale-100 ${isPositive ? 'border-2 border-green-500' : 'border-2 border-red-500'}`}>
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
          title="Schließen"
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
        <h2 className={`text-4xl font-extrabold mb-4 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
          {isPositive ? 'Positive Wirkung!' : 'Negative Wirkung!'}
        </h2>
        <p className="text-xl text-text-light mb-6">{text}</p>
        <p className="text-sm italic text-gray-500 mb-6">Kategorie: {category}</p>
        <button
          onClick={onClose}
          className="mt-4 px-6 py-3 bg-primary text-white font-semibold rounded-lg shadow-md hover:bg-primary-dark transition-colors duration-200"
        >
          Verstanden!
        </button>
      </div>
    </div>
  );
}

export default DrawnChallengeModal;